// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__11TZ0","col":"CardReaderDesc_col__XfJPF","label":"CardReaderDesc_label__1fSNW"};